<label class="checkbox-container"
	   [class.checkbox-container--disabled]="_disabled">
	<input class="form-control"
		   type="checkbox"
		   [attr.id]="id"
		   [class.is-valid]="isValid"
		   [class.is-invalid]="isInValid"
		   [attr.name]="name"
		   [attr.value]="value"
		   [checked]="checked"
		   [disabled]="disabled"
		   [required]="required"
		   (blur)="_onBlur()"
		   (click)="_onInputClick()"
		   (change)="_onInteractionEvent($event)"/>
	<span class="checkmark"></span>
</label>
